<template>
    <v-card-text>
        <div class="text-subtitle-1 mb-2" v-if="title">{{ title }}</div>
        <v-skeleton-loader v-if="loading" type="image"></v-skeleton-loader>
        <div v-else-if="stages.length" class="funnel-wrap">
            <v-chart :options="option"/>
        </div>
    </v-card-text>
</template>

<script>
import 'echarts/lib/chart/funnel';
import 'echarts/lib/component/tooltip';

export default {
    name: "FunnelChart",
    props: {
        title: String,
        loading: Boolean,
        // Ordered [{name, value}] - first stage is treated as the 100% base for every percentage.
        stages: {
            type: Array,
            default: () => []
        },
        // Optional sum shown alongside the last stage (e.g. total contract amount).
        contractAmount: Number
    },
    computed: {
        baseValue() {
            return this.stages.length ? this.stages[0].value : 0;
        },
        option() {
            const lastIndex = this.stages.length - 1;
            const formatLabel = (params) => {
                const percent = this.baseValue > 0 ? Math.round((params.value / this.baseValue) * 100) : 0;
                let text = `${params.name}: ${params.value} (${percent}%)`;
                if (params.dataIndex === lastIndex && this.contractAmount !== undefined && this.contractAmount !== null) {
                    text += `\n${this.contractAmount.toLocaleString('ru-RU')} ₽`;
                }
                return text;
            };
            return {
                textStyle: {
                    color: "#fff",
                    fontFamily: 'Roboto'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: (params) => formatLabel(params).replace('\n', '<br>')
                },
                series: [
                    {
                        type: 'funnel',
                        left: '5%',
                        top: 10,
                        bottom: 10,
                        width: '90%',
                        minSize: '10%',
                        maxSize: '100%',
                        sort: 'none',
                        gap: 2,
                        label: {
                            show: true,
                            position: 'inside',
                            fontSize: 13,
                            formatter: formatLabel
                        },
                        itemStyle: {
                            borderColor: '#1e1e1e',
                            borderWidth: 1
                        },
                        data: this.stages.map(s => ({name: s.name, value: s.value}))
                    }
                ]
            };
        }
    }
}
</script>

<style scoped>
.funnel-wrap {
    width: 100%;
}

.funnel-wrap >>> .echarts {
    width: 100% !important;
    height: 360px;
}
</style>
